let vpl_wasRun = false;

async function videoPreLoader(videoArray){
    if(vpl_wasRun) return;
    vpl_wasRun = true;
    for(let i = 0, l=videoArray.length; i<l; i++){
        console.log(Date.now().toString(), i)
        let vid = videoArray.shift();
        let a = await vpl_prefetch_file(vid);
    }
}


function vpl_prefetch_file(url) {
        const myPromise = new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        let count = 0;
        xhr.addEventListener("load", function () {
            if (xhr.status === 200) {
                var URL = window.URL || window.webkitURL;
                var blob_url = URL.createObjectURL(xhr.response);
                console.log(blob_url + " video completed preloading " + count);
                count ++;
                resolve(null);           
            } else {
                console.log(blob_url + " video preloading failed");
            }
        }, false);
        xhr.send();
    });
    return myPromise;
}

export default videoPreLoader;